export const APP_NAME = 'IoTVisual'
export const APP_VERSION = 'v1.1.2'

export const VMS_USERNAME = 'admin'
export const VMS_PASSWORD = '1234'

export const ROLE_TYPE = {
  SUPERADMIN: 'superadmin',
  PARTSSUPERADMIN: 'partsSuperAdmin',
  ADMIN: 'admin',
  USER: 'user'
}

export const READONLY_PAGES = ['DashboardDisplay',
  'WebReportDisplay',
  'DashboardPreview',
] as any

export const GRID_STACK_CELL_HEIGHT_SPAN_NUM = 24

// export const CHART_OPTIONS = {
//   colors:['#0062CC','#00B900','#FF9300','#EBC147','#D73C74','#8048C8','#6D84C9','#34A0D5'],
//   chartType:[
//       { value:'line', label:'线'},
//       { value:'bar', label:'柱状图'},
//   ],
//   unit:[],
//   lineTypes:[
//       { value:'solid', label:'solid'},
//       { value:'dashed', label:'dashed'},
//       { value:'dotted', label:'dashed'},        
//   ],
//   align:[
//     { value:'left', label:'居左'},
//     { value:'center', label:'居中'},
//     { value:'right', label:'居右'}
//   ],  
//   sampling:[
//       { value:'lttb', label:'lttb'},     
//   ],
//   fontWeight:[
//       { value:'normal', label:'normal'},
//       { value:'bold', label:'bold'},     
//   ],
//   position:[
//       { value:'left', label:'Left'}, 
//       { value:'right', label:'Right'},    
//   ],
//   xAxisType:[
//       { value:'category', label:'Category'}, 
//       { value:'time', label:'Time'},    
//   ],
//   dtFormat:[
//       { value:'yyyy/MM/dd HH:mm:ss', label:'yyyy/MM/dd HH:mm:ss'}, 
//       { value:'yyyy/MM/dd HH:mm', label:'yyyy/MM/dd HH:mm'},
//       { value:'MM/dd HH:mm', label:'MM/dd HH:mm'},
//       { value:'MM/dd HH:mm', label:'MM/dd HH:mm'},
//       { value:'yyyy/MM/dd', label:'yyyy/MM/dd'}, 
//       { value:'HH:mm', label:'HH:mm'}, 
//       { value:'HH:mm:ss', label:'HH:mm:ss'},   
//   ], 
//   xAxisMode:[
//       { value:'time', label:'Time'}, 
//       // { value:'series', label:'Series'},    
//   ], 
//   valueType:[
//       { value:'first', label:'First'},
//       { value:'last', label:'Last'},
//       { value:'sum', label:'SUM'}, 
//       { value:'avg', label:'Avg'}, 
//       { value:'min', label:'Min'},
//       { value:'max', label:'Max'},   
//   ],           
// }

// export const TABLE_OPTIONS = {
//     dataType:[
//         { value:'string', label:'字符串'},
//         { value:'number', label:'数字'},
//         { value:'datetime', label:'日期'},
//         // { value:'hidden', label:'隐藏'},
//     ],
//     operator:[
//         { value:'==', label:'等于'},
//         { value:'>', label:'大于'},
//         { value:'<', label:'小于'},
//         { value:'>=', label:'大于等于'},
//         { value:'<=', label:'小于等于'}
//     ],
// }

// export const COMMON_OPTIONS = {
//     colors:['#0062CC','#00B900','#FF9300','#EBC147','#D73C74','#8048C8','#6D84C9','#34A0D5'],
//     dataSource:[
//         { value:'apm', label:'IoT时序数据源'},
//         { value:'dw', label:'数据仓湖'}
//         // { value:'simulate', label:'模拟数据源'}
//     ],
//     inputType:[
//         { value:'datetime', label:'日期'},
//         { value:'input', label:'输入框'},
//         { value:'selector', label:'选择框'},
//     ],
//     dtTypes:[
//         // { value:'Custom', label:'自定义'},
//         { value:'ThisDay', label:'当天'},  
//         { value:'ThisWeek', label:'本周'},
//         { value:'ThisMonth', label:'当月'},        
//         { value:'LastHour', label:'过去1小时'},
//         { value:'LastDay', label:'过去24小时'},
//         { value:'Last3Day', label:'过去三天'},
//         { value:'Last7Day', label:'过去一周'},
//         { value:'Last30Day', label:'过去一月'},
//         { value:'ThisYear', label:'本年度'},
//     ],    
// }